import { Suspense, ComponentProps } from 'react';
import { Route, withRouter, RouteComponentProps } from 'react-router-dom';

import { fomatParentPath } from '../../utils';
import {
    MAccountBind,
} from '../../lib';

function RouteAccountBind(props: RouteComponentProps & ComponentProps<any>) {
    const parentPath: string = fomatParentPath(props);
    console.log('here', props, parentPath)
    return (
        <>
            <Route weId={`${props.weId || ''}_nkq7on`} path={`${parentPath}/passport/bind`} component={MAccountBind} />
        </>
    )
}

export default withRouter(RouteAccountBind);
